(function() {
  'use strict';

  var GT_OFFSET = -6;
  var DAYS_ES = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MONTHS_ES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var MONTHS_SHORT_ES = ['ene.','feb.','mar.','abr.','may.','jun.','jul.','ago.','sep.','oct.','nov.','dic.'];

  function getNowGT() {
    var now = new Date();
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utc + GT_OFFSET * 3600000);
  }

  function pointInPolygon(point, polygon) {
    var x = point[0], y = point[1];
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var xi = polygon[i][0], yi = polygon[i][1];
      var xj = polygon[j][0], yj = polygon[j][1];
      var intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function pointInGeometry(lng, lat, geometry) {
    var coverage = window.CelovendoCoverage;
    if (coverage && typeof coverage.contains === 'function') {
      return coverage.contains(lng, lat, geometry);
    }
    var point = [lng, lat];
    if (geometry.type === 'Polygon') {
      return pointInPolygon(point, geometry.coordinates[0]);
    } else if (geometry.type === 'MultiPolygon') {
      for (var p = 0; p < geometry.coordinates.length; p++) {
        if (pointInPolygon(point, geometry.coordinates[p][0])) return true;
      }
    }
    return false;
  }

  var geoCache = {};

  function loadGeoJSON(url) {
    if (geoCache[url]) return Promise.resolve(geoCache[url]);
    return fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        geoCache[url] = data;
        return data;
      });
  }

  function findDeliveryZone(lat, lng, config) {
    // Location service is the single adapter for CelovendoCoverage. Keeping
    // this indirection prevents this estimator from fetching stale, separate
    // Guatemala/Xela coverage files.
    if (window.CelovendoGeo && typeof window.CelovendoGeo.findDeliveryZone === 'function') {
      return window.CelovendoGeo.findDeliveryZone(lat, lng, config);
    }
    return Promise.reject(new Error('El servicio de cobertura no está disponible.'));
  }

  function isValidTime(str) {
    if (!str || str === 'cerrado') return false;
    var parts = str.split(':');
    if (parts.length !== 2) return false;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    return !isNaN(h) && !isNaN(m) && h >= 0 && h <= 23 && m >= 0 && m <= 59;
  }

  function parseBusinessHours(config) {
    var days = ['sun','mon','tue','wed','thu','fri','sat'];
    var hours = {};
    for (var i = 0; i < days.length; i++) {
      var d = days[i];
      var open = config.hours[d + '_open'] || '';
      var close = config.hours[d + '_close'] || '';
      if (isValidTime(open) && isValidTime(close)) {
        hours[i] = {
          open: parseTime(open),
          close: parseTime(close)
        };
      } else {
        hours[i] = null;
      }
    }
    return hours;
  }

  function parseTime(str) {
    var parts = str.split(':');
    return { h: parseInt(parts[0], 10), m: parseInt(parts[1], 10) };
  }

  function timeToMinutes(t) {
    return t.h * 60 + t.m;
  }

  function isBusinessDay(date, bh) {
    return bh[date.getDay()] !== null;
  }

  function addBusinessDays(date, days, bh) {
    var result = new Date(date.getTime());
    result.setHours(0, 0, 0, 0);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result, bh)) added++;
    }
    return result;
  }

  function nextBusinessOpen(date, bh, cutoff) {
    cutoff = cutoff || 0;
    var d = new Date(date.getTime());
    var dayInfo = bh[d.getDay()];
    if (dayInfo) {
      var nowMin = d.getHours() * 60 + d.getMinutes();
      var effectiveClose = timeToMinutes(dayInfo.close) - cutoff;
      if (nowMin < effectiveClose) {
        if (nowMin >= timeToMinutes(dayInfo.open)) {
          return d;
        } else {
          d.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
          return d;
        }
      }
    }
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    for (var attempt = 0; attempt < 14; attempt++) {
      var info = bh[d.getDay()];
      if (info) {
        d.setHours(info.open.h, info.open.m, 0, 0);
        return d;
      }
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  // productType: immediate | backorder | slowback | xela | marketplace.
  // days: días hábiles del tipo (data-delivery-days, desde snippets/cv-delivery-type.liquid).
  // Sin valor, backorder usa 7 y slowback 10. marketplace siempre llega por Cargo Expreso.
  function calculateEstimate(zoneInfo, productType, config, now, days) {
    if (!now) now = getNowGT();
    var bh = parseBusinessHours(config);
    var cutoff = parseInt(config.cutoff, 10) || 0;
    var baseDate = new Date(now.getTime());
    var leadDays = parseInt(days, 10);

    if (productType === 'backorder' || productType === 'slowback') {
      if (!(leadDays > 0)) leadDays = productType === 'slowback' ? 10 : 7;
      baseDate = addBusinessDays(now, leadDays, bh);
      baseDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    }

    var zone = zoneInfo.zone;
    var result = {};

    // Marketplace y bajo pedido van solo por Cargo Expreso, en cualquier zona, como
    // en el checkout. Bajo pedido ya corrió sus días en baseDate y tarda uno más;
    // marketplace usa sus días como tránsito.
    if (productType === 'marketplace' || productType === 'backorder' || productType === 'slowback') {
      var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
      var transitDays = productType === 'marketplace' && leadDays > 0 ? leadDays : 1;
      var arrivalDate = addBusinessDays(dispatchDate, transitDays, bh);
      var dayInfo = bh[arrivalDate.getDay()];
      if (dayInfo) {
        arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
      }
      result.method = 'Cargo Expreso';
      result.date = arrivalDate;
      result.type = 'cargo';
    } else if (productType === 'xela') {
      if (zone === 'messenger_xela') {
        var minutes = parseInt(config.minutes.messenger_xela, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger_ciudad' || zone === 'messenger' || zone === 'cargo_expreso') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else {
        return null;
      }
    } else {
      if (zone === 'messenger_ciudad') {
        var minutes = parseInt(config.minutes.messenger_ciudad, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger') {
        var minutes = parseInt(config.minutes.messenger, 10) || 90;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger_xela') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else if (zone === 'cargo_expreso') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else {
        return null;
      }
    }

    var locLabel = zoneInfo.cityZone || zoneInfo.municipio || '';
    if (locLabel) locLabel = shortenMuniName(locLabel);
    result.formatted = formatDate(result.date, result.type, locLabel);
    result.formattedRange = formatRange(result.date, result.type, locLabel, bh, now);
    result.municipio = zoneInfo.municipio;
    result.departamento = zoneInfo.departamento;
    return result;
  }

  function shortenMuniName(name) {
    if (!name) return name;
    var s = name;
    s = s.replace(/^(El|La)\s+/i, '');
    s = s.replace(/\bSanta\s+/g, 'Sta. ');
    s = s.replace(/\bSanto\s+/g, 'Sto. ');
    s = s.replace(/\bSan\s+/g, 'S. ');
    var words = {
      'Pedro':'P.','José':'J.','Jose':'J.','Juan':'J.','Marcos':'M.',
      'Pablo':'P.','Francisco':'F.','Miguel':'M.','Antonio':'A.',
      'Martín':'M.','Martin':'M.','Lucas':'L.','Bartolomé':'B.',
      'Bartolome':'B.','Cristóbal':'C.','Cristobal':'C.','Andrés':'A.',
      'Andres':'A.','Mateo':'M.','Felipe':'F.','Bernardino':'B.',
      'Agustín':'A.','Agustin':'A.','Raymundo':'R.','Benito':'B.'
    };
    Object.keys(words).forEach(function(w) {
      s = s.replace(new RegExp('\\b' + w + '\\b', 'g'), words[w]);
    });
    return s.replace(/\s{2,}/g, ' ').trim();
  }

  function formatDate(date, type, locationLabel) {
    var now = getNowGT();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffDays = Math.round((dateDay - today) / 86400000);

    var dayName;
    if (diffDays === 0) {
      dayName = 'hoy';
    } else if (diffDays === 1) {
      dayName = 'mañana';
    } else if (diffDays === 2) {
      dayName = 'pasado mañana, ' + DAYS_ES[date.getDay()];
    } else {
      dayName = 'el ' + DAYS_ES[date.getDay()] + ' ' + date.getDate() + ' de ' + MONTHS_ES[date.getMonth()];
    }

    var suffix = locationLabel ? ' en ' + locationLabel : '';

    if (type === 'messenger' && diffDays <= 1) {
      var hours = date.getHours();
      var mins = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var h12 = hours % 12;
      if (h12 === 0) h12 = 12;
      var timeStr = h12 + ':' + (mins < 10 ? '0' : '') + mins + ' ' + ampm;
      return 'Recíbelo ' + dayName + ' a las ' + timeStr + suffix;
    } else {
      return 'Recíbelo ' + dayName + suffix;
    }
  }

  // Ancho de la ventana del mensajero: el mismo delivery_margin_minutes (60 por
  // defecto) del servicio de tarifas, para que el carrito y el checkout prometan
  // la misma hora.
  var MESSENGER_WINDOW_MINUTES = 60;

  // Sube a la siguiente hora en punto (11:30 -> 12:00; 11:00 se queda).
  function ceilHour(date) {
    var d = new Date(date.getTime());
    if (d.getMinutes() || d.getSeconds() || d.getMilliseconds()) d.setHours(d.getHours() + 1);
    d.setMinutes(0, 0, 0);
    return d;
  }

  function hourLabel(date) {
    return date.getHours() % 12 || 12;
  }

  /*
   * Texto del carrito como rango, con las reglas del servicio de tarifas (lo que
   * dice el checkout). Mensajero hoy o mañana: una ventana en horas en punto,
   * "Recíbelo hoy de 2 a 3pm en Zona 4"; se redondea hacia arriba para que el
   * fin nunca quede antes de lo estimado. Lo demás (Cargo Expreso, bajo
   * pedido): del día estimado al siguiente día hábil, corto para que quepa en
   * el carrito: "Recíbelo del martes 6 al 7 de oct. en Cobán". Solo el primer
   * día lleva nombre; su mes solo se repite si cambia ("del sábado 31 de oct.
   * al 2 de nov.").
   */
  function formatRange(date, type, locationLabel, bh, now) {
    if (!now) now = getNowGT();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffDays = Math.round((dateDay - today) / 86400000);
    var suffix = locationLabel ? ' en ' + locationLabel : '';

    if (type === 'messenger' && diffDays <= 1) {
      var from = ceilHour(date);
      var to = ceilHour(new Date(from.getTime() + MESSENGER_WINDOW_MINUTES * 60000));
      if (to.getDate() === date.getDate()) {
        var fromPeriod = from.getHours() >= 12 ? 'pm' : 'am';
        var toPeriod = to.getHours() >= 12 ? 'pm' : 'am';
        return 'Recíbelo ' + (diffDays === 0 ? 'hoy' : 'mañana') + ' de ' + hourLabel(from) +
          (fromPeriod === toPeriod ? '' : fromPeriod) + ' a ' + hourLabel(to) + toPeriod + suffix;
      }
    }

    var last = addBusinessDays(date, 1, bh);
    var sameMonth = last.getMonth() === date.getMonth();
    return 'Recíbelo del ' + DAYS_ES[date.getDay()] + ' ' + date.getDate() + (sameMonth ? '' : ' de ' + MONTHS_SHORT_ES[date.getMonth()]) +
      ' al ' + last.getDate() + ' de ' + MONTHS_SHORT_ES[last.getMonth()] + suffix;
  }

  function getCentroid(geometry) {
    var coords;
    if (geometry.type === 'Polygon') {
      coords = geometry.coordinates[0];
    } else if (geometry.type === 'MultiPolygon') {
      coords = geometry.coordinates[0][0];
    } else {
      return null;
    }
    var sumLng = 0, sumLat = 0;
    for (var i = 0; i < coords.length; i++) {
      sumLng += coords[i][0];
      sumLat += coords[i][1];
    }
    return [sumLat / coords.length, sumLng / coords.length];
  }

  function DeliveryEstimator(containerId) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;

    this.config = this.loadConfig();
    if (!this.config) return;

    this.productType = this.container.getAttribute('data-product-type') || 'immediate';
    this.deliveryDays = parseInt(this.container.getAttribute('data-delivery-days'), 10) || 0;
    this.hasStockXela = this.container.hasAttribute('data-stock-xela');
    this.map = null;
    this.deptSelect = this.container.querySelector('.delivery-dept-select');
    this.muniSelect = this.container.querySelector('.delivery-muni-select');
    this.resultArea = this.container.querySelector('.delivery-result');
    this.resultText = this.container.querySelector('.delivery-result-text');
    this.resultMethod = this.container.querySelector('.delivery-result-method');
    this.resultIcon = this.container.querySelector('.delivery-result-icon');
    this.geoBtn = this.container.querySelector('.delivery-geo-btn');
    this.loadingEl = this.container.querySelector('.delivery-loading');
    this.initialEl = this.container.querySelector('.delivery-estimator__initial');
    this.countdownEl = this.container.querySelector('.delivery-estimator__result-countdown');
    this.countdownInterval = null;
    this.addToCartBtn = this.container.querySelector('.delivery-estimator__add-to-cart');
    this.locationSummary = this.container.querySelector('.delivery-estimator__location-summary');
    this.locationText = this.container.querySelector('.delivery-estimator__location-text');
    this.locationChangeBtn = this.container.querySelector('.delivery-estimator__location-change');
    this.deptMuniList = null;
    this._loadingFromCookie = false;
    this._locationRequestId = 0;
    this._shipTargets = [];
    this._inlineEstimate = null;

    this.init();
    this.bindShippingUpdates();
  }

  DeliveryEstimator.prototype.loadConfig = function() {
    var el = document.getElementById('delivery-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch(e) {
      return null;
    }
  };

  DeliveryEstimator.prototype.init = function() {
    var self = this;
    this.initMap();
    this.loadDeptMuniList().then(function() {
      self.populateDepartments();
      self.bindEvents();
      self.loadFromCookie();
    });
  };

  DeliveryEstimator.prototype.loadFromCookie = function() {
    if (!window.CelovendoLocation) {
      var self = this;
      document.addEventListener('cv:location-ready', function handler() {
        document.removeEventListener('cv:location-ready', handler);
        self.loadFromCookie();
      });
      return;
    }
    var loc = window.CelovendoLocation.getLocation();
    if (!loc || !loc.dept || !loc.muni || !loc.confirmed) return;
    var requestId = ++this._locationRequestId;
    var self = this;
    if (this.deptSelect) {
      var deptVal = this.findOptionValue(this.deptSelect, loc.dept);
      if (deptVal) {
        this.deptSelect.value = deptVal;
        this.populateMunicipios(deptVal);
        if (this.muniSelect) {
          var muniVal = this.findOptionValue(this.muniSelect, loc.muni);
          if (muniVal) this.muniSelect.value = muniVal;
        }
      }
    }
    if (loc.lat && loc.lng) {
      this._loadingFromCookie = true;
      this.setMarker(loc.lat, loc.lng, 12);
      var self2 = this;
      var clearFlag = function() {
        setTimeout(function() { self2._loadingFromCookie = false; }, 50);
      };
      if (this.map) {
        this.map.once('moveend', clearFlag);
        setTimeout(function() { self2._loadingFromCookie = false; }, 1000);
      } else {
        this._loadingFromCookie = false;
      }
      // A saved zone is only a cache. Re-classify it against the active shared
      // coverage configuration before showing a delivery promise.
      findDeliveryZone(loc.lat, loc.lng, this.config).then(function(zoneInfo) {
        if (requestId !== self._locationRequestId) return;
        self.showResult(zoneInfo, true, !!loc.precise, { lat: loc.lat, lng: loc.lng });
      }).catch(function() {
        if (requestId !== self._locationRequestId) return;
        self.showError('No se pudo verificar la cobertura para esta ubicación.');
      });
    } else {
      this.showError('No se pudo verificar la cobertura para esta ubicación.');
    }
  };

  DeliveryEstimator.prototype.initMap = function() {
    var mapEl = this.container.querySelector('.delivery-map');
    if (!mapEl || typeof L === 'undefined') return;

    this.map = L.map(mapEl, {
      center: [14.6, -90.5],
      zoom: 8,
      scrollWheelZoom: true,
      zoomControl: true,
      dragging: true
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
      maxZoom: 18
    }).addTo(this.map);

    this.centerPin = this.container.querySelector('.delivery-estimator__center-pin');
    this.mapHint = this.container.querySelector('.delivery-estimator__map-hint');
    this.moveTimeout = null;
    this.mapMoveCount = 0;
    this.mapMovesRequired = 2;

    var self = this;
    this.map.on('movestart', function() {
      if (self.centerPin) self.centerPin.classList.add('delivery-estimator__center-pin--dragging');
    });
    this.map.on('moveend', function() {
      if (self.centerPin) self.centerPin.classList.remove('delivery-estimator__center-pin--dragging');
      if (self._loadingFromCookie) return;
      self.mapMoveCount++;
      if (self.mapMoveCount < self.mapMovesRequired) return;
      clearTimeout(self.moveTimeout);
      self.moveTimeout = setTimeout(function() {
        var center = self.map.getCenter();
        self.onMapMove(center.lat, center.lng);
      }, 400);
    });

    setTimeout(function() {
      if (self.map) self.map.invalidateSize();
    }, 300);
  };

  DeliveryEstimator.prototype.loadDeptMuniList = function() {
    var self = this;
    if (this.deptMuniList) return Promise.resolve();
    var url = this.config.geoJsonUrls.deptMuniList;
    return fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        self.deptMuniList = data;
      })
      .catch(function() {
        self.deptMuniList = {};
      });
  };

  DeliveryEstimator.prototype.populateDepartments = function() {
    if (!this.deptSelect || !this.deptMuniList) return;
    this.deptSelect.innerHTML = '<option value="">Selecciona departamento</option>';
    var depts = Object.keys(this.deptMuniList).sort();
    for (var i = 0; i < depts.length; i++) {
      var opt = document.createElement('option');
      opt.value = depts[i];
      opt.textContent = depts[i];
      this.deptSelect.appendChild(opt);
    }
  };

  DeliveryEstimator.prototype.populateMunicipios = function(dept) {
    if (!this.muniSelect || !this.deptMuniList) return;
    this.muniSelect.innerHTML = '<option value="">Selecciona municipio</option>';
    if (!dept || !this.deptMuniList[dept]) {
      this.muniSelect.disabled = true;
      return;
    }
    this.muniSelect.disabled = false;
    var munis = this.deptMuniList[dept].sort();
    for (var i = 0; i < munis.length; i++) {
      var opt = document.createElement('option');
      opt.value = munis[i];
      opt.textContent = munis[i];
      this.muniSelect.appendChild(opt);
    }
  };

  DeliveryEstimator.prototype.bindEvents = function() {
    var self = this;

    if (this.deptSelect) {
      this.deptSelect.addEventListener('change', function() {
        self.populateMunicipios(this.value);
        self.hideResult();
      });
    }

    if (this.muniSelect) {
      this.muniSelect.addEventListener('change', function() {
        if (this.value) {
          self.onMunicipioSelected(self.deptSelect.value, this.value);
        }
      });
    }

    if (this.geoBtn) {
      this.geoBtn.addEventListener('click', function() {
        self.useGeolocation();
      });
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', function() {
        var realBtn = document.querySelector('.product-form__add-button[data-action="add-to-cart"]');
        if (realBtn && !realBtn.disabled) realBtn.click();
      });
    }

    if (this.locationChangeBtn) {
      this.locationChangeBtn.addEventListener('click', function() {
        self.expandControls();
      });
    }

    var geoBtnMini = this.container.querySelector('.delivery-geo-btn-mini');
    if (geoBtnMini) {
      geoBtnMini.addEventListener('click', function() {
        self.useGeolocation();
      });
    }

    var geoBtnMap = this.container.querySelector('.delivery-geo-btn-map');
    if (geoBtnMap) {
      geoBtnMap.addEventListener('click', function() {
        self.useGeolocation();
      });
    }
  };

  DeliveryEstimator.prototype.onMapMove = function(lat, lng) {
    if (this.mapHint) this.mapHint.classList.add('delivery-estimator__map-hint--hidden');
    this.showLoading();
    var self = this;
    var requestId = ++this._locationRequestId;
    findDeliveryZone(lat, lng, this.config).then(function(zoneInfo) {
      if (requestId !== self._locationRequestId) return;
      self.updateDropdownsFromZone(zoneInfo);
      self.showResult(zoneInfo, false, true, { lat: lat, lng: lng });
    }).catch(function() {
      if (requestId !== self._locationRequestId) return;
      self.showError('No se pudo determinar la ubicación.');
    });
  };

  DeliveryEstimator.prototype.onMunicipioSelected = function(dept, muni) {
    this.showLoading();
    var self = this;
    var requestId = ++this._locationRequestId;
    var url = this.config.geoJsonUrls.municipios;
    loadGeoJSON(url).then(function(data) {
      var feature = null;
      for (var i = 0; i < data.features.length; i++) {
        var f = data.features[i];
        var fMuni = (f.properties.municipio || f.properties.MUNICIPIO || '').toLowerCase();
        var fDept = (f.properties.departamen || f.properties.DEPARTAMEN || f.properties.departamento || '').toLowerCase();
        if (fMuni === muni.toLowerCase() && fDept === dept.toLowerCase()) {
          feature = f;
          break;
        }
      }

      if (feature) {
        var centroid = getCentroid(feature.geometry);
        if (centroid) {
          self.setMarker(centroid[0], centroid[1], 12);
        }
        var lat = centroid ? centroid[0] : 14.6;
        var lng = centroid ? centroid[1] : -90.5;
        return findDeliveryZone(lat, lng, self.config);
      } else {
        return { zone: 'unknown', municipio: muni, departamento: dept };
      }
    }).then(function(zoneInfo) {
      if (requestId !== self._locationRequestId) return;
      self.showResult(zoneInfo, false, false);
    }).catch(function() {
      if (requestId !== self._locationRequestId) return;
      self.showError('No se pudo calcular la estimación.');
    });
  };

  DeliveryEstimator.prototype.useGeolocation = function() {
    if (!navigator.geolocation) {
      this.showError('Tu navegador no soporta geolocalización.');
      return;
    }
    if (this.mapHint) this.mapHint.classList.add('delivery-estimator__map-hint--hidden');
    this.mapMoveCount = this.mapMovesRequired;
    this.showLoading();
    var self = this;
    var requestId = ++this._locationRequestId;
    navigator.geolocation.getCurrentPosition(function(pos) {
      if (requestId !== self._locationRequestId) return;
      var lat = pos.coords.latitude;
      var lng = pos.coords.longitude;
      self.setMarker(lat, lng, 16);
      findDeliveryZone(lat, lng, self.config).then(function(zoneInfo) {
        if (requestId !== self._locationRequestId) return;
        self.updateDropdownsFromZone(zoneInfo);
        self.showResult(zoneInfo, false, true, { lat: lat, lng: lng });
      }).catch(function() {
        if (requestId !== self._locationRequestId) return;
        self.showError('No se pudo determinar tu ubicación.');
      });
    }, function() {
      if (requestId !== self._locationRequestId) return;
      self.showError('No se pudo obtener tu ubicación. Verifica los permisos.');
    }, { enableHighAccuracy: false, timeout: 10000 });
  };

  DeliveryEstimator.prototype.setMarker = function(lat, lng, zoom) {
    if (!this.map) return;
    this.map.setView([lat, lng], zoom || Math.max(this.map.getZoom(), 10));
  };

  DeliveryEstimator.prototype.updateDropdownsFromZone = function(zoneInfo) {
    if (!zoneInfo.departamento || !zoneInfo.municipio) return;
    if (this.deptSelect) {
      var deptVal = this.findOptionValue(this.deptSelect, zoneInfo.departamento);
      if (deptVal) {
        this.deptSelect.value = deptVal;
        this.populateMunicipios(deptVal);
        if (this.muniSelect) {
          var muniVal = this.findOptionValue(this.muniSelect, zoneInfo.municipio);
          if (muniVal) this.muniSelect.value = muniVal;
        }
      }
    }
  };

  DeliveryEstimator.prototype.findOptionValue = function(select, text) {
    if (!text) return null;
    var lower = text.toLowerCase();
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value.toLowerCase() === lower) {
        return select.options[i].value;
      }
    }
    return null;
  };

  DeliveryEstimator.prototype.stopCountdown = function() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    if (this.countdownEl) {
      this.countdownEl.textContent = '';
      this.countdownEl.classList.remove('delivery-estimator__result-countdown--visible');
    }
  };

  DeliveryEstimator.prototype.startCountdown = function(config) {
    this.stopCountdown();
    if (!this.countdownEl || !config.urgency) return;

    var now = getNowGT();
    var dayKey = String(now.getDay());
    var dayCfg = config.urgency[dayKey];
    if (!dayCfg || !dayCfg.visible) return;

    var cutoffTime = new Date(now.getTime());
    cutoffTime.setHours(dayCfg.hour, dayCfg.minute, 0, 0);

    var remainingMs = cutoffTime.getTime() - now.getTime();
    if (remainingMs <= 0) return;

    var self = this;

    function formatCountdown(ms) {
      var totalSec = Math.floor(ms / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var parts = [];
      if (h > 0) parts.push(String(h).padStart(2, '0'));
      parts.push(String(m).padStart(2, '0'));
      parts.push(String(s).padStart(2, '0'));
      return parts.join(':');
    }

    function updateDisplay() {
      var now2 = getNowGT();
      var remaining = cutoffTime.getTime() - now2.getTime();
      if (remaining <= 0) {
        self.stopCountdown();
        return;
      }
      self.countdownEl.innerHTML = '\u26A1 Ordena en los pr\u00F3ximos <span class="countdown-timer">' + formatCountdown(remaining) + '</span>';
      self.countdownEl.classList.add('delivery-estimator__result-countdown--visible');
    }

    updateDisplay();
    this.countdownInterval = setInterval(updateDisplay, 1000);
  };

  DeliveryEstimator.prototype.showResult = function(zoneInfo, fromCookie, isPrecise, coords) {
    this.hideLoading();
    this.stopCountdown();
    if (this.initialEl) this.initialEl.style.display = 'none';
    if (!zoneInfo || zoneInfo.zone === 'outside') {
      this.showError('Ubicación fuera de Guatemala. Solo realizamos envíos dentro de Guatemala.');
      return;
    }

    var effectiveType = this.productType;
    if (effectiveType === 'immediate' && this.hasStockXela && zoneInfo.zone === 'messenger_xela') {
      effectiveType = 'xela';
    }
    var estimate = calculateEstimate(zoneInfo, effectiveType, this.config, undefined, this.deliveryDays);
    if (!estimate) {
      var msg = zoneInfo.zone === 'messenger_both'
        ? 'Esta ubicación está cubierta por ambas zonas. Confirma la cobertura para ver la estimación.'
        : 'No se pudo verificar la cobertura para calcular la estimación.';
      this.showError(msg);
      return;
    }

    if (fromCookie) {
      this.populateInlineResult(estimate);
      return;
    }

    if (!fromCookie && window.CelovendoLocation && zoneInfo.municipio && zoneInfo.departamento) {
      var mapCenter = coords || (this.map ? this.map.getCenter() : null);
      var lat = mapCenter ? mapCenter.lat : 14.6349;
      var lng = mapCenter ? mapCenter.lng : -90.5069;
      window.CelovendoLocation.setLocation(zoneInfo.departamento, zoneInfo.municipio, lat, lng, zoneInfo.zone, zoneInfo.cityZone, true, !!isPrecise);
    }

    this.showResultFull(estimate);
  };

  DeliveryEstimator.prototype.showResultFull = function(estimate) {
    if (this.resultArea) {
      this.resultArea.style.display = 'flex';
      this.resultArea.classList.remove('delivery-estimator__result--error');
      this.resultArea.classList.add('delivery-estimator__result--visible');
    }
    if (this.resultText) this.resultText.textContent = estimate.formattedRange;
    if (this.resultMethod) {
      var methodText = estimate.method;
      if (estimate.municipio) {
        methodText += ' — ' + estimate.municipio;
        if (estimate.departamento) methodText += ', ' + estimate.departamento;
      }
      this.resultMethod.textContent = methodText;
    }
    if (this.resultIcon) {
      if (estimate.type === 'messenger') {
        this.resultIcon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ff9b00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>';
      } else {
        this.resultIcon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ff9b00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
      }
    }
    this.startCountdown(this.config);
    if (this.addToCartBtn) this.addToCartBtn.classList.add('delivery-estimator__add-to-cart--visible');
    this.collapseControls();
    this.renderShipping(this.container.querySelector('[data-cv-ship-options]'));
  };

  // "Envío a Zona 4", "Envío a San Juan Sacatepéquez": el lugar del header, sin abreviar.
  function shippingTitle() {
    var service = window.CelovendoLocation;
    var loc = service && typeof service.getLocation === 'function' ? service.getLocation() : null;
    var place = loc && loc.confirmed ? loc.cityZone || loc.muni : '';
    return place ? 'Envío a ' + place : undefined;
  }

  /*
   * Métodos, precios y rango de entrega de cada uno, del servicio de tarifas
   * (shipping-quote.js) para este producto solo, 1 unidad, sin el carrito: el
   * precio de envío de un producto no cambia con lo que lleve el cliente.
   * En la fila "Entrega:" de la página de producto ([data-cv-ship-row]), si el
   * servicio no da opciones (sin pin, sin URL, en modo de pruebas o caído) se
   * muestra la estimación del tema; fuera de esa fila el bloque queda oculto.
   */
  DeliveryEstimator.prototype.renderShipping = function(target) {
    if (!target) return;
    var self = this;
    var row = target.closest('[data-cv-ship-row]');
    var shipping = window.CelovendoShipping;
    if (!shipping || !shipping.enabled()) {
      if (row) this.renderEstimateFallback(target, row);
      return;
    }
    if (this._shipTargets.indexOf(target) === -1) this._shipTargets.push(target);
    var line = {
      variantId: this.container.getAttribute('data-variant-id'),
      tipo: this.container.getAttribute('data-cv-tipo') || 'immediate',
      bodega: this.container.getAttribute('data-cv-bodega') || 'gt',
      dias: parseInt(this.container.getAttribute('data-cv-dias'), 10) || 0,
      priceCents: parseInt(this.container.getAttribute('data-price-cents'), 10) || 0
    };
    var shown = shipping.show(target, shipping.quoteProduct(line), {
      compact: target.classList.contains('cv-ship-options--compact'),
      eta: true,
      fastestFirst: true,
      icons: true,
      note: false,
      title: shippingTitle()
    });
    if (!row) return;
    var token = target.getAttribute('data-cv-ship-token');
    shown.then(function(ok) {
      if (target.getAttribute('data-cv-ship-token') !== token) return;
      if (ok) row.hidden = false;
      else self.renderEstimateFallback(target, row);
    });
  };

  // Respaldo de la fila "Entrega:": método y rango que calcula el tema, sin precio.
  DeliveryEstimator.prototype.renderEstimateFallback = function(target, row) {
    var estimate = this._inlineEstimate;
    if (!estimate || !estimate.date) {
      target.hidden = true;
      row.hidden = true;
      return;
    }
    target.innerHTML = '';
    var title = document.createElement('p');
    title.className = 'cv-ship-options__title';
    title.textContent = shippingTitle() || 'Envío a tu ubicación';
    var list = document.createElement('ul');
    list.className = 'cv-ship-options__list';
    var item = document.createElement('li');
    item.className = 'cv-ship-options__item';
    var name = document.createElement('span');
    name.className = 'cv-ship-options__name';
    var shipping = window.CelovendoShipping;
    if (shipping && typeof shipping.icon === 'function') {
      list.className += ' cv-ship-options__list--icons';
      name.innerHTML = shipping.icon(estimate.type === 'cargo' ? 'cargo_expreso' : 'mensajero');
    }
    name.appendChild(document.createTextNode(estimate.method));
    var eta = document.createElement('span');
    eta.className = 'cv-ship-options__eta';
    eta.textContent = formatRange(estimate.date, estimate.type, '', parseBusinessHours(this.config));
    item.appendChild(name);
    item.appendChild(eta);
    list.appendChild(item);
    target.appendChild(title);
    target.appendChild(list);
    target.hidden = false;
    row.hidden = false;
  };

  // Precio con descuento de una variante: data-variant-prices ("id:centavos,...").
  function variantPrice(container, variant) {
    var pairs = (container.getAttribute('data-variant-prices') || '').split(',');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split(':');
      if (pair[0] === String(variant.id) && pair[1] !== undefined && isFinite(parseInt(pair[1], 10))) return parseInt(pair[1], 10);
    }
    return typeof variant.price === 'number' ? variant.price : null;
  }

  // Otra variante cambia el precio (el carrito no cambia la cotización del producto).
  DeliveryEstimator.prototype.bindShippingUpdates = function() {
    var self = this;
    function refresh() {
      self._shipTargets.forEach(function(target) {
        if (!target.hidden) self.renderShipping(target);
      });
    }
    document.addEventListener('variant:changed', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.id) return;
      self.container.setAttribute('data-variant-id', String(variant.id));
      var cents = variantPrice(self.container, variant);
      if (cents !== null) self.container.setAttribute('data-price-cents', String(cents));
      refresh();
    });
  };

  /*
   * Ubicación ya guardada: en la página de producto la entrega va en la fila
   * "Entrega:" (debajo de "Stock:") y la tarjeta del estimador se oculta. Sin
   * esa fila, el estimador muestra su resultado completo.
   */
  DeliveryEstimator.prototype.populateInlineResult = function(estimate) {
    var target = document.getElementById('delivery-inline-ship-options');
    if (!target) {
      this.showResultFull(estimate);
      return;
    }
    var shippingCard = this.container.closest('.product-block-list__item--shipping');
    if (shippingCard) shippingCard.style.display = 'none';
    this._inlineEstimate = estimate;
    this.renderShipping(target);
  };

  DeliveryEstimator.prototype.showError = function(msg) {
    this.hideLoading();
    this.stopCountdown();
    if (this.addToCartBtn) this.addToCartBtn.classList.remove('delivery-estimator__add-to-cart--visible');
    this.expandControls();
    if (this.initialEl) this.initialEl.style.display = 'none';
    if (this.resultArea) {
      this.resultArea.style.display = 'flex';
      this.resultArea.classList.add('delivery-estimator__result--visible');
      this.resultArea.classList.add('delivery-estimator__result--error');
    }
    if (this.resultText) this.resultText.textContent = msg;
    if (this.resultMethod) this.resultMethod.textContent = '';
    if (this.resultIcon) {
      this.resultIcon.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
    }
  };

  DeliveryEstimator.prototype.collapseControls = function() {
    var dept = this.deptSelect ? this.deptSelect.options[this.deptSelect.selectedIndex] : null;
    var muni = this.muniSelect ? this.muniSelect.options[this.muniSelect.selectedIndex] : null;
    var deptName = dept && dept.value ? dept.text : '';
    var muniName = muni && muni.value ? muni.text : '';
    var label = muniName && deptName ? muniName + ', ' + deptName : deptName || 'Ubicación seleccionada';
    if (this.locationText) this.locationText.textContent = label;
    this.container.classList.add('delivery-estimator--collapsed');
  };

  DeliveryEstimator.prototype.expandControls = function() {
    this.container.classList.remove('delivery-estimator--collapsed');
  };

  DeliveryEstimator.prototype.hideResult = function() {
    this.stopCountdown();
    if (this.addToCartBtn) this.addToCartBtn.classList.remove('delivery-estimator__add-to-cart--visible');
    if (this.resultArea) {
      this.resultArea.style.display = 'none';
      this.resultArea.classList.remove('delivery-estimator__result--visible');
      this.resultArea.classList.remove('delivery-estimator__result--error');
    }
    if (this.initialEl) this.initialEl.style.display = '';
  };

  DeliveryEstimator.prototype.showLoading = function() {
    this.hideResult();
    if (this.loadingEl) this.loadingEl.style.display = 'flex';
  };

  DeliveryEstimator.prototype.hideLoading = function() {
    if (this.loadingEl) this.loadingEl.style.display = 'none';
  };

  window.DeliveryEstimator = DeliveryEstimator;
  window.calculateDeliveryEstimate = calculateEstimate;
  window.findDeliveryZone = findDeliveryZone;

  var activeEstimator = null;

  document.addEventListener('DOMContentLoaded', function() {
    var container = document.getElementById('delivery-estimator');
    if (container) {
      activeEstimator = new DeliveryEstimator('delivery-estimator');
    }
  });

  document.addEventListener('cv:location-changed', function() {
    if (activeEstimator) {
      activeEstimator.loadFromCookie();
    }
  });

  document.addEventListener('cv:location-ready', function() {
    if (activeEstimator) {
      activeEstimator.loadFromCookie();
    }
  });
})();
